if (typeof loadeMoreSlider_G === 'undefined') {
  globalThis.loadeMoreSlider_G = null;
}

(function () {
	const initSlider = () => {
		const sliders = document.querySelectorAll(".product-card-js");
		const dir = document.querySelector('html').getAttribute("dir");

		let nextEl = ".product-button-group .swiper-button-next";
		let prevEl = ".product-button-group .swiper-button-prev";
		if (dir === 'rtl') {
			[nextEl, prevEl] = [prevEl, nextEl];
		}
		sliders.forEach((slider, index) => {
			if (slider?.swiper) return;

			const productSlider = new Swiper(slider, {
				pagination: {
					el: ".product-pagination .swiper-pagination",
					clickable: true,
				},
				navigation: {
					nextEl: nextEl,
					prevEl: prevEl,
				},
				allowTouchMove: true,
				breakpoints: {
					990: {
						allowTouchMove: false,
					}
				},
			});
		});
	};

	initSlider();
	loadeMoreSlider_G = initSlider;

	document.addEventListener("shopify:section:load", function () {
		initSlider();
	});

let resizeRaf = null;

window.addEventListener("resize", () => {
  if (resizeRaf) {
    cancelAnimationFrame(resizeRaf);
  }

  resizeRaf = requestAnimationFrame(() => {
    document.querySelectorAll(".product-card-js").forEach((slider) => {
      const swiper = slider.swiper;

      if (!swiper) return;

      // 現在表示しているスライドを保持
      const currentIndex = swiper.activeIndex;

      // 新しいコンテナ幅でSwiperを再計算
      swiper.updateSize();
      swiper.updateSlides();

      // 新しいslide幅に合わせてtranslateを即座に補正
      swiper.slideTo(currentIndex, 0, false);
    });
  });
});

})();